import React  from 'react'
import DropDown from '../dropdown';
import PropTypes from "prop-types";
import { Products } from '../../../api/services/next';

const ProductsDropDown = ({HotelID, ...rest}) => {
    const itemClassName = React.useCallback(item => {
        return item.ApplicableRestrictions?.length > 0 ? "restricted":null
    }, [])
    
    return <DropDown search api={Products.Search} spec={{ HotelID }} textField="Name" itemClassName={itemClassName} valueField="Id" {...rest} />
}

ProductsDropDown.propTypes = {
    HotelID: PropTypes.any
}
export default ProductsDropDown
